import React, {useContext, useEffect} from "react";
import {UserContext} from "../../Context/UserContext";
import {MenuContext} from "../../Context/MenuContext";

export const DEFAULT_ROUTES = [];

export const useUserServerRoute = () => {

    const {currentUser} = useContext(UserContext);
    const {customMenus} = useContext(MenuContext);

    const [serverMenus, setServerMenus] = React.useState([]);



    useEffect(() => {

        const loadMenus = () => {
            const menus = customMenus;
            const userAuthorities = currentUser ? currentUser.roles : [];
            const menusByUser = [...DEFAULT_ROUTES, ...menus].filter(x => {

                if (x.authorities.length > 0) {
                    const userCanAccess = x.authorities.find(x => userAuthorities.includes(x.authority));
                    if (!userCanAccess) {
                        return false;
                    }
                }
                return true;
            });

            const menuGroupByParent = menusByUser.reduce((acc, menu) => {

                if (!acc[menu.parent]) {
                    acc[menu.parent] = [];
                }

                if (!acc[menu.parent].find(x => x.id === menu.id)) {
                    acc[menu.parent].push(menu);
                }

                return acc;
            }, {});


            const rootMenus = menuGroupByParent["undefined"];

            const newMenus = rootMenus.map((x) => {
                x.children = menuGroupByParent[x.id];
                return x;
            })
            setServerMenus(newMenus);
        }

        loadMenus();
    }, [customMenus, currentUser]);


    return {
        serverMenus
    }

}
